export default {
  steps: {
    'instruction': 'Istruzioni',
    'on': 'Su',
    'step': 'passo',
    'gotoStep': 'Visualizza questo passo'
  }
}
